import React, { useState } from 'react';
import { surveyQuestions as defaultSurveyQuestions, answerOptions, forceInfo } from '../data/surveyQuestions';

function SurveyQuestions({ onComplete, questions, peerName }) {
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [responses, setResponses] = useState({});
  
  // Use provided questions or default to survey questions
  const surveyQuestions = questions || defaultSurveyQuestions;

  const question = surveyQuestions[currentQuestion];
  const progress = Math.round(((currentQuestion + 1) / surveyQuestions.length) * 100);
  const isAnswered = responses[question.id] !== undefined;

  const handleResponse = (value) => {
    setResponses({
      ...responses,
      [question.id]: value
    });
  };

  const handleNext = () => {
    if (currentQuestion < surveyQuestions.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
      // Scroll to top
      window.scrollTo(0, 0);
    } else {
      // Survey complete
      onComplete(responses);
    }
  };

  const handlePrevious = () => {
    if (currentQuestion > 0) {
      setCurrentQuestion(currentQuestion - 1);
      window.scrollTo(0, 0);
    }
  };

  const allAnswered = Object.keys(responses).length === surveyQuestions.length;

  return (
    <div className="survey-container">
      <div className="survey-header">
        <h1>Creative Work Footprint Survey{peerName ? ` for ${peerName}` : ''}</h1>
        <div className="progress-info">
          <span className="question-counter">Question {currentQuestion + 1} of {surveyQuestions.length}</span>
          <div className="progress-bar-container">
            <div className="progress-bar" style={{ width: `${progress}%` }}></div>
          </div>
          <span className="progress-percentage">{progress}%</span>
        </div>
      </div>

      <div className="survey-content">
        <div className="question-card">
          <h2 className="question-text">{question.question}</h2>

          <div className="answer-options">
            {answerOptions.map((option) => (
              <button
                key={option.value}
                className={`answer-button ${responses[question.id] === option.value ? 'selected' : ''}`}
                onClick={() => handleResponse(option.value)}
                aria-pressed={responses[question.id] === option.value}
              >
                <span className="answer-emoji">{option.emoji}</span>
                <span className="answer-label">{option.label}</span>
              </button>
            ))}
          </div>
        </div>

        <div className="survey-navigation">
          <button
            className="btn btn-secondary"
            onClick={handlePrevious}
            disabled={currentQuestion === 0}
          >
            ← Previous
          </button>

          <button
            className="btn btn-primary"
            onClick={handleNext}
            disabled={!isAnswered}
          >
            {currentQuestion === surveyQuestions.length - 1 ? 'Complete Survey' : 'Next →'}
          </button>
        </div>

        {!allAnswered && (
          <p className="unanswered-warning">
            {surveyQuestions.length - Object.keys(responses).length} questions remaining
          </p>
        )}
      </div>
    </div>
  );
}

export default SurveyQuestions;
